import React from "react";
import { ComponentProjectListPageInitialState, PageNewState } from ".";

export const ComponentProjectListPageContext = React.createContext({
  pageState: ComponentProjectListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
